import './imageGalleryOld.scss';
import { Icon } from '@rocketmakers/armstrong';
import * as React from 'react';
import { icons } from '../../content/icons';
import { ImageUtils } from '../../utils/image';
import { SwiperUtils } from '../../utils/swiper';
import FullScreenSectionSwiper from '../layout/fullScreenSectionSwiper';
import { Portal } from '../portal';
import { LazyCosmosImage } from './cosmosImage';
export const ImageGallery = ({ images, darkenBg }) => {
    const [currentImage, setCurrentImage] = React.useState(-1);
    const swiperProps = React.useMemo(() => ({
        ...SwiperUtils.Config.defaults(),
        ...SwiperUtils.Config.navigation('white'),
        ...SwiperUtils.Config.perView(1),
        ...SwiperUtils.Config.autoplay(4000),
    }), []);
    return (<>
      <FullScreenSectionSwiper darkenBg={darkenBg} className="image-gallery-old" slides={images.map((image, i) => (<div className="image-gallery-image" key={image.ticket} onClick={() => setCurrentImage(i)}>
            <LazyCosmosImage className="image-desktop" alt={image.caption} ticket={image.ticket} size={ImageUtils.imageSizes.large}/>
            <LazyCosmosImage className="image-mobile" alt={image.caption} ticket={image.ticket} size={ImageUtils.imageSizes.small}/>
          </div>))} swiperProps={swiperProps} foreground={() => images.map((image) => image.caption ? (<div className="image-caption-wrapper" data-image-open={currentImage >= 0}>
                <ImageGalleryCaption caption={image.caption} key={image.ticket} clickForMore/>
              </div>) : (<></>))}/>

      {currentImage >= 0 && <ImageGalleryFullScreened image={!!images[currentImage] && images[currentImage]} onClose={() => setCurrentImage(-1)}/>}
    </>);
};
ImageGallery.defaultProps = {
    darkenBg: false,
};
const ImageGalleryCaption = ({ caption, clickForMore }) => (<div className="image-caption">
    <Icon {...icons.up}/>

    <div>
      <p>{caption}</p>
      {clickForMore && (<p>
          <em>Click for full screen</em>
        </p>)}
    </div>
  </div>);
const ImageGalleryFullScreened = ({ image, onClose }) => (<Portal rootClassName="image-gallery-full-screened-wrapper" appendTo="main">
    <div className="image-gallery-full-screened" onClick={onClose}>
      <LazyCosmosImage className="image-desktop" alt={image.caption} ticket={image.ticket} size={ImageUtils.imageSizes.large}/>
      {!!image.caption && <ImageGalleryCaption caption={image.caption} key={image.ticket}/>}
    </div>
  </Portal>);
